import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		width: "100%",
		maxWidth: "100%",
		padding: theme.spacing(2.5),
		height: `calc(100% - 48px)`,
		overflowX: "hidden",
		overscrollBehaviorX: "none",
		backgroundColor: theme.palette.fancyBackground,
	},

	contentWrapper: {
		height: "100%",
		maxWidth: "100%",
		overflowX: "hidden",
		overflowY: "hidden",
		display: "flex",
		flexDirection: "column",
	},
}));

const MainContainer = ({ children }) => {
	const classes = useStyles();

	return (
		<Container maxWidth={false} className={classes.mainContainer}>
			<div className={classes.contentWrapper}>{children}</div>
		</Container>
	);
};

export default MainContainer;
